module.exports = __webpack_public_path__ + "img/classdhed.fcd37185.svg";